// extracted by mini-css-extract-plugin
export default {"mainDiv":"StepsSection_mainDiv__8lcRO","container":"StepsSection_container__0y68a","bottomDiv":"StepsSection_bottomDiv__YzEdb","loadingDiv":"StepsSection_loadingDiv__s4Ela"};